export default "__VITE_ASSET__BqApTQA4__"